<template>
  <div v-if="dataPermission.includes('CNPS_SCON_REFUND_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết yêu cầu hoàn tiền</h1>
      <div style="float: right">
        <button
          @click="showModalRefund"
          v-if="reqRefund.status === 'NEW' && dataPermission.includes('CNPS_SCON_REFUND_EDIT')"
          class="f12 font-medium btn btn-outline-secondary mr-2"
        >
          Sửa
        </button>
        <button
          @click="sendApprove(reqRefund.id)"
          v-if="canEdit(reqRefund.status)"
          class="f12 font-medium btn btn-outline-secondary mr-2"
        >
          Gửi duyệt
        </button>
        <button
          @click="approve(reqRefund.id)"
          v-if="
            canApprovenReject(reqRefund.status) &&
            dataPermission.includes('CNPS_SCON_REFUND_APPROVE')
          "
          class="f12 font-medium btn btn-outline-secondary mr-2"
        >
          Duyệt
        </button>
        <button
          @click="reject(reqRefund.id)"
          v-if="
            canApprovenReject(reqRefund.status) &&
            dataPermission.includes('CNPS_SCON_REFUND_APPROVE')
          "
          class="f12 font-medium btn btn-outline-secondary mr-2"
        >
          Từ chối
        </button>
        <button
          @click="changeStatus(reqRefund) && dataPermission.includes('CNPS_SCON_REFUND_CANCEL')"
          v-if="canCancel(reqRefund.status)"
          class="f12 font-medium btn btn-outline-secondary mr-2"
        >
          Huỷ
        </button>
        <button
          @click="$router.push({ path: `/list-refund` })"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin chung</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã biên bản hoàn tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ reqRefund.code }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã phiếu thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <a @click="openReiceipt(reqRefund)" href="javascript:;">{{
                    reqRefund.receiptCode
                  }}</a>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã giao dịch đã thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ reqRefund.transactionCode }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã hợp đồng/ phụ lục<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <a @click="openContract(reqRefund)" href="javascript:;">{{
                    reqRefund.contractCode
                  }}</a>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ngày ký<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.signTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Hình thức thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.paymentType | mapTextStatus(optionPaymentType) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ngày đã thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.receiptTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ngày thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.payTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge" :class="[reqRefund.status ? reqRefund.status : '']">
                    {{ reqRefund.status | mapTextStatus(optionStatus) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Lý do hoàn tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.reason | mapTextStatus(refundReason) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số tiền hoàn<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.refundAmount | transformMoney }} VNĐ
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tình trạng KPI<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.kpiStatus | transformData(Config.kpiStatus) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số tiền trên phiếu thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.amount | transformMoney }} VNĐ
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Người tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="reqRefund.creator && reqRefund.creator.name"
                >
                  {{ reqRefund.creator.name }} - {{ reqRefund.creator.email }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="reqRefund.status === 'APPROVED'">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian duyệt<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.approvedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="reqRefund.status === 'APPROVED'">
              <label for="" class="col-sm-4 col-form-label"
                >Người duyệt<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{
                    reqRefund.userApproved && reqRefund.userApproved.name
                      ? reqRefund.userApproved.name
                      : ''
                  }}
                  -
                  {{
                    reqRefund.userApproved && reqRefund.userApproved.email
                      ? reqRefund.userApproved.email
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="reqRefund.status === 'REJECTED'">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.rejectedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="reqRefund.status === 'REJECTED'">
              <label for="" class="col-sm-4 col-form-label"
                >Người từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{
                    reqRefund.userRejected && reqRefund.userRejected.name
                      ? reqRefund.userRejected.name
                      : ''
                  }}
                  -
                  {{
                    reqRefund.userRejected && reqRefund.userRejected.email
                      ? reqRefund.userRejected.email
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="reqRefund.reasonReject">
              <label for="" class="col-sm-4 col-form-label"
                >Lý do từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ reqRefund.reasonReject }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="reqRefund.note">
              <label for="" class="col-sm-4 col-form-label"
                >Ghi chú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ reqRefund.note }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin TKNH nhận tiền</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Đối tượng hoàn tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ reqRefund.refundRecipient | mapTextStatus(objectRefund) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ngân hàng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ reqRefund.bankName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số tài khoản<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ reqRefund.accountNumber }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên tài khoản<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ reqRefund.accountName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Chi nhánh<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ reqRefund.branch }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail" v-if="reqRefund.orderPaymentRes">
            <h1>Thông tin đề nghị thanh toán</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã đề nghị<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <a @click="openPayment(reqRefund)" href="javascript:;">{{
                    reqRefund.orderPaymentRes.code
                  }}</a>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span
                    class="badge"
                    :class="[
                      reqRefund.orderPaymentRes.status ? reqRefund.orderPaymentRes.status : '',
                    ]"
                  >
                    {{
                      reqRefund.orderPaymentRes.status | transformData(Config.paymentOrderStatus)
                    }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail" v-if="reqRefund.reason == 'SOFTWARE_DEVICE'">
            <h1>Thông tin thiết bị/phần mềm hoàn tiền</h1>
            <div class="row">
              <div class="table-responsive text-center col-md-12">
                <table class="w-100 mb-2">
                  <thead class="thead-gray">
                    <tr>
                      <th scope="col">
                        <input
                          type="checkbox"
                          v-model="selectProducts"
                          class="text-center"
                          @change="handleChange"
                          disabled
                        />
                      </th>
                      <th scope="col"><b>Loại sản phẩm</b></th>
                      <th scope="col"><b>Tên sản phẩm</b></th>
                      <th scope="col"><b>Số tiền (VNĐ)</b></th>
                      <th scope="col"><b>Mã serial</b></th>
                      <th scope="col" v-if="isRentLend"><b>Khấu hao</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="table-row"
                      v-for="(item, index) in reqRefund.infoProducts"
                      :key="index"
                      disabled
                    >
                      <td class="txt-center">
                        <input
                          type="checkbox"
                          class="text-center"
                          v-model="selectedPro"
                          :value="item"
                          @change="handleChange"
                          disabled
                        />
                      </td>
                      <td class="text-center">{{ item.type }}</td>
                      <td class="text-center">{{ item.name }}</td>
                      <td class="text-center">{{ item.price | transformMoney }}</td>
                      <td class="text-center">{{ item.serial }}</td>
                      <td class="text-center" v-if="isRentLend">{{ item?.depreciationAmount }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <div class="form-group row img-list mr-0 ml-0">
            <ul v-viewer>
              <li v-for="(item, index) in reqRefund.images" :key="index">
                <a href="javascript:void(0)">
                  <img :src="item" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Sửa hoàn tiền-->
    <b-modal
      ignore-enforce-focus-selector="input"
      v-model="refundModal"
      centered
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <template #modal-header="{ close }">
        <h5>Sửa thông tin hoàn tiền</h5>
        <b-button
          size="sm"
          variant="light"
          @click="close(), resetRefundData(), (refundModal = false)"
        >
          x
        </b-button>
      </template>
      <ValidationObserver class="w-100" ref="formRefund">
        <form @submit.prevent="checkValidate">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="reason" name="Lý do hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <select
                      class="select"
                      v-model="reqRefund.reason"
                      :options="refundReason"
                      disabled
                    >
                      <option v-for="option in refundReason" :value="option.id" :key="option.id">
                        {{ option.text }}
                      </option>
                    </select>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="receiptCode" name="Mã phiếu thu">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Mã phiếu thu</label>
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefund.receiptCode" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="receiptCode" name="Mã hợp đồng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã hợp đồng <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefund.contractCode" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Mã giao dịch đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">{{ reqRefund.transactionCode }}</p>
                </div>
              </div>
              <div class="form-group form-row" v-if="reqRefund.reason !== 'CONTRACT_COINCIDENCE'">
                <label for="" class="col-sm-4 col-form-label">Hình thức thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.paymentType | mapTextStatus(optionPaymentType) }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row" v-if="reqRefund.reason !== 'CONTRACT_COINCIDENCE'">
                <label for="" class="col-sm-4 col-form-label">Ngày đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.receiptTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Ngày thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.payTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <ValidationProvider
                rules=""
                vid="refundAmount"
                name="Số tiền hoàn"
                v-if="reqRefund.reason === 'CONTRACT_COINCIDENCE'"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Số tiền hoàn</label>
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefund.refundAmount" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="kpiStatus" name="Tình trạng KPI">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Tình trạng KPI</label>
                  <div class="col-sm-8">
                    <Select2 v-model="reqRefund.kpiStatus" :options="Config.kpiStatus"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <h6>Upload ảnh</h6>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in reqRefund.images" :key="index">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="item" />
                      <span @click="removeImg(index)">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div
                      v-else-if="reqRefund.images && reqRefund.images.length < 10"
                      class="add-img"
                    >
                      <span class="bx bx-plus text-center"></span>
                      <input
                        type="file"
                        ref="fileImgRefund"
                        accept="image/jpeg, image/png"
                        @input="onSelectFile"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <h6 class="mb-2" v-if="reqRefund.reason !== 'CONTRACT_COINCIDENCE'">
            Thông tin thiết bị/phần mềm hoàn tiền
          </h6>
          <div class="row" v-if="reqRefund.reason !== 'CONTRACT_COINCIDENCE'">
            <div class="table-responsive text-center col-md-12">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        v-model="selectProducts"
                        class="text-center"
                        @change="handleChange"
                      />
                    </th>
                    <th scope="col"><b>Loại sản phẩm</b></th>
                    <th scope="col"><b>Số tiền (VNĐ)</b></th>
                    <th scope="col" v-if="isRentLend"><b>Số tiền hoàn (VNĐ)</b></th>
                    <th scope="col"><b>Mã serial</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row" v-for="(item, index) in listProduct" :key="index">
                    <td class="txt-center">
                      <input
                        type="checkbox"
                        class="text-center"
                        v-model="selectedPro"
                        :value="item"
                        @change="handleChange"
                      />
                    </td>
                    <td class="text-center">{{ item.type }}</td>
                    <td class="text-center">
                      {{ (isRentLend ? item.deposit : item.price) | transformMoney }}
                    </td>
                    <td class="text-center" v-if="isRentLend">
                      <input
                        type="number"
                        v-model.number="item.refundAmount"
                        @input="onRefundAmountChange(item)"
                        :disabled="!selectedPro.includes(item)"
                        style="width: 120px; text-align: right"
                        min="0"
                      />
                    </td>
                    <td class="text-center">{{ item.serial }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <ValidationProvider
              rules="required|numberCheck"
              vid="textValue"
              name="Số tiền hoàn"
              v-if="reqRefund.reason !== 'CONTRACT_COINCIDENCE'"
            >
              <div class="form-group d-flex flex-row" slot-scope="{ errors }">
                <label for="" class="col-sm-5 col-form-label"
                  ><i>Tổng số tiền hoàn/phiếu thu (VNĐ)</i><span style="color: red"> *</span></label
                >
                <div class="col-sm-7">
                  <input v-model.trim="textValue" :disabled="isRentLend" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <h6 class="mb-2">Thông tin TKNH nhận tiền hoàn</h6>
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="refundRecipient" name="Đối tượng hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Đối tượng hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2
                      v-model="reqRefund.refundRecipient"
                      :options="objectRefund"
                      @change="queryObjectRefund($event)"
                    >
                    </Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="bankName" name="Tên ngân hàng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên ngân hàng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8" v-if="reqRefund.reason == 'CONTRACT_COINCIDENCE'">
                    <Select2 :options="listBank" v-model="reqRefund.bankId"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                  <div
                    class="col-sm-8"
                    v-if="
                      reqRefund.refundRecipient === 'REFUND_MERCHANT' &&
                      reqRefund.reason !== 'CONTRACT_COINCIDENCE'
                    "
                  >
                    <select class="select" :options="listBank" v-model="reqRefund.bankId" disabled>
                      <option v-for="option in listBank" :value="option.id" :key="option.id">
                        {{ option.text }}
                      </option>
                    </select>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                  <div
                    class="col-sm-8"
                    v-if="
                      reqRefund.refundRecipient !== 'REFUND_MERCHANT' &&
                      reqRefund.reason !== 'CONTRACT_COINCIDENCE'
                    "
                  >
                    <Select2 :options="listBank" v-model="reqRefund.bankId"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountNumber"
                name="Số tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.accountNumber"
                      :disabled="
                        reqRefund.refundRecipient === 'REFUND_MERCHANT' &&
                        reqRefund.reason !== 'CONTRACT_COINCIDENCE'
                      "
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider rules="required|minMaxName_6" vid="branch" name="Chi nhánh">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Chi nhánh <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.branch"
                      :disabled="
                        reqRefund.refundRecipient === 'REFUND_MERCHANT' &&
                        reqRefund.reason !== 'CONTRACT_COINCIDENCE'
                      "
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountName"
                name="Tên tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.accountName"
                      :disabled="
                        reqRefund.refundRecipient === 'REFUND_MERCHANT' &&
                        reqRefund.reason !== 'CONTRACT_COINCIDENCE'
                      "
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-12">
              <ValidationProvider rules="required|minMaxName_1" vid="note" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-2 col-form-label"
                    >Ghi chú<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-10">
                    <input v-model.trim="reqRefund.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="checkValidate"> Đồng ý </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ReceiptService } from '@/services/receipts.service'
  import { CommonService } from '@/services/common.service'
  import { BankService } from '@/services/bank.service'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'
  import cloneDeep from 'lodash/cloneDeep'
  export default {
    mixins: [mxItemAction],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectProducts: {
        get: function () {
          return this.listProduct ? this.selectedPro?.length === this.listProduct?.length : false
        },
        set: function (value) {
          var selectedPro = []
          if (value) {
            this.listProduct.forEach(function (item) {
              selectedPro.push(item)
            })
          }
          this.selectedPro = selectedPro
        },
      },
      isRentLend() {
        return this.reqRefund.reason === 'RENT_LEND'
      },
    },
    data() {
      return {
        Config,
        showLoading: false,
        id: this.$route.params.id,
        reqRefund: {
          images: [],
          infoProducts: [],
        },
        listProduct: [],
        loadingImage: false,
        refundModal: false,
        refundReason: Config.refundReason,
        listBank: [],
        customerRes: {},
        objectRefund: Config.refundRecipient,
        optionPaymentType: Config.typePayment,
        selectedPro: [],
        optionStatus: Config.refundReportStatus,
        textValue: '',
        originalRefundItem: null,
      }
    },
    watch: {
      selectedPro: {
        handler: function () {
          this.calculateTotalRefund()
        },
        deep: true,
      },
    },
    created() {
      this.fetchData()
      this.getListBank()
    },
    methods: {
      async getListBank() {
        try {
          const data = await BankService.listBank()
          if (data.success) {
            this.listBank = data.data.map(e => {
              return {
                id: e.id,
                text: e.bankName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async infoRefund(receiptCode) {
        try {
          this.showLoading = true
          const data = await BankService.merchantBank({
            code: receiptCode,
          })
          if (data.success) {
            this.customerRes = data.data.customerRes
            this.listProduct = data.data.infoProducts
            this.reqRefund.payTime = data.data.payTime
            this.reqRefund.paymentType = data.data.paymentType
            this.reqRefund.receiptTime = data.data.receiptTime
            this.reqRefund.transactionCode = data.data.transactionCode
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
      async onSelectFile() {
        const input = this.$refs.fileImgRefund
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3(files[0])
      },
      removeImg(index) {
        this.reqRefund.images.splice(index, 1)
      },
      async uploadS3(file) {
        try {
          if (file) {
            this.loadingImage = true
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const res = await CommonService.uploadImg(formData)
            if (res.code === 1000) {
              this.reqRefund.images.push(res.data[0])
            }
          }
        } catch (error) {
        } finally {
          this.loadingImage = false
        }
      },
      queryObjectRefund(e) {
        if (e === 'REFUND_MERCHANT') {
          this.reqRefund = {
            ...this.reqRefund,
            bankId: this.customerRes.bankId,
            bankName: this.customerRes.bankName,
            accountNumber: this.customerRes.accountNo,
            branch: this.customerRes.branch,
            accountName: this.customerRes.holderName,
          }
        } else {
          delete this.reqRefund.bankId
          delete this.reqRefund.bankName
          delete this.reqRefund.accountNumber
          delete this.reqRefund.branch
          delete this.reqRefund.accountName
        }
      },
      resetRefundData() {
        if (this.originalRefundItem) {
          this.reqRefund = cloneDeep(this.originalRefundItem)
          this.selectedPro = cloneDeep(this.originalRefundItem.infoProducts || [])
          this.textValue = this.originalRefundItem.refundAmount
        }
      },
      async showModalRefund() {
        this.originalRefundItem = cloneDeep(this.reqRefund)
        this.textValue = this.reqRefund.refundAmount

        let data = null
        if (this.isRentLend) {
          data = await BankService.merchantBankV1({
            code: this.reqRefund.receiptCode,
            reason: this.reqRefund.reason,
            refundHistoryId: this.reqRefund.id,
          })
        } else {
          data = await BankService.merchantBank({
            code: this.reqRefund.receiptCode,
          })
        }

        if (data.success) {
          this.listProduct = data.data.infoProducts
          this.customerRes = data.data.customerRes

          // Logic tự động tick checkbox cho items có refundAmount
          this.selectedPro = []
          if (this.reqRefund.infoProducts && Array.isArray(this.reqRefund.infoProducts)) {
            this.reqRefund.infoProducts.forEach(savedItem => {
              const matchingProduct = this.listProduct.find(p => p.serial === savedItem.serial)
              if (matchingProduct) {
                matchingProduct.refundAmount = savedItem.refundAmount || 0
                this.selectedPro.push(matchingProduct)
              }
            })
          }
        }
        this.refundModal = true
      },
      async checkValidate() {
        this.reqRefund.infoProducts = this.selectedPro
        this.reqRefund.refundHistoryId = this.id
        this.reqRefund.refundAmount = Number(this.textValue)

        const isSuccess = await this.$refs.formRefund.validate()
        if (!isSuccess && this.reqRefund.infoProducts?.length < 1) {
          return
        }
        if (isSuccess) {
          if (this.reqRefund.reason === 'REFUND_MERCHANT') {
            this.editRefund(this.reqRefund)
          } else {
            this.checkBankAccount(this.reqRefund)
          }
        }
      },
      async checkBankAccount(reqRefund) {
        try {
          this.showLoading = true
          const data = await BankService.checkBank({
            bankId: reqRefund.bankId,
            holderName: reqRefund.accountName,
            accountNo: reqRefund.accountNumber,
          })
          if (data.success) {
            this.editRefund(reqRefund)
          } else {
            if (data.code === 641 || data.code === 642) {
              const flag = await this.approveMx(
                'Trong một số trường hợp dịch vụ kiểm tra thông tin phía ngân hàng không ổn định, thông báo này cũng sẽ được hiển thị. Nếu đã đảm bảo tính xác thực của thông tin, bạn có thể chọn tiếp tục?'
              )
              if (flag === true) {
                await this.editRefund(reqRefund)
              }
            } else {
              this.showFailMx(data.message)
              this.resetRefundData()
            }
          }
        } catch (error) {
          console.log(error)
          this.resetRefundData()
        } finally {
          this.showLoading = false
        }
      },
      async editRefund(reqRefund) {
        try {
          this.showLoading = true
          this.refundModal = false
          const req = cloneDeep(reqRefund)
          req.bankName = this.listBank.find(s => s.id === req.bankId)?.text ?? ''
          const data = await ReceiptService.editRefund(req)
          if (data.success) {
            await this.fetchData()
            this.showSuccessMx('Sửa thông tin hoàn tiền thành công')
          } else {
            this.showFailMx(data.message)
            this.resetRefundData()
          }
        } catch (err) {
          console.log(err)
          this.resetRefundData()
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        try {
          const data = await ReceiptService.detailRefund({
            id: this.id,
          })
          if (data.success) {
            this.reqRefund = data.data
            this.selectedPro = data.data.infoProducts
          }
        } catch (error) {
          console.log(error)
        }
      },
      handleChange() {
        this.$nextTick(() => {
          this.calculateTotalRefund()
        })
      },
      calculateTotalRefund() {
        if (this.isRentLend) {
          // Logic cho RENT_LEND: Tổng = tổng deposit của items được chọn + tổng refundAmount đã nhập
          const totalRefundAmount = this.selectedPro.reduce((total, item) => {
            const refundAmount = Number(item.refundAmount) || 0
            return total + refundAmount
          }, 0)
          this.reqRefund.refundAmount = totalRefundAmount
          this.textValue = totalRefundAmount
        } else {
          // Logic cho các reason khác: Tổng = tổng price của items được chọn
          const totalRefundAmount = this.selectedPro.reduce((total, item) => {
            const price = Number(item.price) || 0
            return total + price
          }, 0)
          this.reqRefund.refundAmount = totalRefundAmount
          this.textValue = totalRefundAmount
        }
      },
      onRefundAmountChange(item) {
        // Validate refundAmount không được âm
        if (item.refundAmount < 0) {
          item.refundAmount = 0
        }
        this.$nextTick(() => {
          this.calculateTotalRefund()
        })
      },
      openPayment(data) {
        window.open(`/list-order/${data.orderPaymentRes.id}`)
      },
      openReiceipt(data) {
        window.open(`/detail-receipts/${data.receiptId}`)
      },
      openContract(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.contractId)}`, '_blank')
          } else {
            window.open(
              `/sales-manager/detail-paper/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(
              `/contract-detail-ecommerce/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.contractId)}`, '_blank')
          }
        }
      },
    },
  }
</script>

<style scoped>
  .select {
    background-color: #e2e7ed;
    border: 1px solid #ccc;
  }

  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }
</style>
